import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ErrorPage({
  error: __error
}) {
  return /*#__PURE__*/_jsxs(ErrorMessage, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "quartzCore.errorMessage"
    }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "quartzCore.errorCta_jsx",
      options: {
        href: 'https://status.hubspot.com'
      },
      elements: {
        Link
      }
    })]
  });
}